<template>
    <v-menu
        ref="menu"
        v-model="menu"
        transition="scale-transition"
        offset-y
        min-width="auto"
    >
        <template v-slot:activator="{ on, attrs }">
            <v-text-field
                v-model="dateYear"
                label="Year"
                readonly
                v-bind="attrs"
                v-on="on"
                outlined
            >
                <template v-slot:append>
                    <SaveStatus :save-status="saveStatus" />
                </template>
            </v-text-field>
        </template>

        <v-date-picker
            ref="picker"
            v-model="date"
            :max="(new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substring(0, 10)"
            :reactive="true"
        ></v-date-picker>
    </v-menu>
</template>

<script>
import SaveStatus from './AutoSaveStatus.vue';
export default {
    props: {
        yearAttended: {
            type: Number,
            default: null   
        },

        saveStatus: {   
            type: String,
            default: ''
        }
    },

    components: {
        SaveStatus
    },

    data: function () {
        return {
            date: null,
            menu: false,
            dateYear: this.yearAttended,
        }
    },

    watch: {
        menu (val) {
            val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'))
        },

        date: {
            handler (val) {
                if(val){
                    let selectedDate = new Date(val);
                    this.dateYear = selectedDate.getFullYear();
                    this.$emit('update-year', this.dateYear);
                }
            },
        },

        yearAttended:  {
            handler (val) {
                if(val) this.dateYear = val;
            }
        }
    },
    
    methods: {
      save () {
        console.log('saving year')
        // console.log('date: ', date)
        // this.$refs.menu.save(date)
      },
    },
}
</script>